import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboCodPool`, method: 'GET', body: null, token: token})
}
